import React from 'react';
import CheckboxGroup from '../CheckboxGroup';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';
import { copyFor, capitalization } from '../../copy/copy';

const GetUpdatesCheckbox = props => {
    return (
        <Field
            {...props}
            name={props.name || 'getUpdates'}
            defaultChecked={props.defaultChecked}
            component={CheckboxGroup}
            label={
                props.labelText ||
                (props.isEU
                    ? copyFor('formFields', 'updatesEU')
                    : copyFor(
                          'formFields',
                          'updates',
                          undefined,
                          capitalization.eachWord
                      ))
            }
        />
    );
};

GetUpdatesCheckbox.propTypes = {
    defaultChecked: PropTypes.bool,
    isEU: PropTypes.bool,
    sidebar: PropTypes.bool,
    keepExistingCapitalization: PropTypes.bool,
    labelText: PropTypes.string,
    name: PropTypes.string,
    style: PropTypes.object,
};

export default GetUpdatesCheckbox;
